import React, { useState, useEffect } from "react";
import { startSessionTimer } from "@globalholdings/ui-common-functions";

export default function SessionTimer(props) {
  const { sessionTime, sessionCallback } = props;
  const [sessionStarted, setSessionStarted] = useState(false);

  useEffect(() => {
    if (!sessionStarted) {
      startSessionTimer(() => {
        sessionCallback();
      }, sessionTime);
      setSessionStarted(true);
    }
  }, [sessionCallback, sessionStarted, sessionTime]);

  return <div></div>;
}
